import React from 'react';
import { Button, ButtonProps, styled } from '@mui/material';

import { FontSizes } from 'constants/font-sizes';
import { Colors } from 'constants/colors';
import { fontSecondary } from 'constants/font-family';

export interface StyledButtonProps extends ButtonProps {
  color: 'error' | 'info' | 'primary' | 'secondary';
  variant: 'text' | 'outlined' | 'contained';
  size: 'small' | 'medium' | 'large';
}

export const StyledButton = styled((props: StyledButtonProps) => (
  <Button {...props} />
))({
  textTransform: 'none',

  '&.MuiButton-sizeSmall': {
    height: '25px',
    fontSize: FontSizes.fontSize11,
  },

  '&.MuiButton-sizeMedium': {
    height: '30px',
    fontSize: FontSizes.fontSize11,
  },

  '&.MuiButton-sizeLarge': {
    height: '34px',
    fontSize: FontSizes.fontSize14,
  },

  '&.MuiButton-outlined': {
    border: `1px solid ${Colors.blackPearl}`,
    color: Colors.blackPearl,

    '& .MuiSvgIcon-root': {
      color: Colors.blackPearl,
    },

    '&.Mui-disabled': {
      borderColor: Colors.blackPearl,
      color: Colors.blackPearl,
      opacity: 0.2,

      '& .MuiSvgIcon-root': {
        color: Colors.blackPearl,
      },
    },

    '&.MuiButton-outlinedError': {
      borderColor: Colors.red,
      color: Colors.red,

      '& .MuiSvgIcon-root': {
        color: Colors.red,
      },

      '&.Mui-disabled': {
        borderColor: Colors.red,
        color: Colors.red,
        opacity: 0.2,

        '& .MuiSvgIcon-root': {
          color: Colors.red,
        },
      },
    },

    '&.MuiButton-outlinedPrimary': {
      border: 'none',
      color: Colors.white,
      background: Colors.tabGradient,

      '&.Mui-disabled': {
        border: 'none',
        color: Colors.white,
        opacity: 0.2,
      },
    },

    '&.MuiButton-outlinedSecondary': {
      borderColor: Colors.blackPearl,
      color: Colors.blackPearl,

      '&.Mui-disabled': {
        borderColor: Colors.binge,
        color: Colors.blackPearl,
        opacity: 0.2,
      },
    },

    '&:hover': {
      opacity: 0.8,
    },
  },

  '&.MuiButton-contained': {
    border: `1px solid ${Colors.white}`,
    backgroundColor: Colors.white,
    color: Colors.black,

    '& .MuiSvgIcon-root': {
      color: Colors.black,
    },

    '&.Mui-disabled': {
      borderColor: Colors.white,
      backgroundColor: Colors.white,
      color: Colors.black,
      opacity: 0.2,

      '& .MuiSvgIcon-root': {
        color: Colors.black,
      },
    },

    '&.MuiButton-containedError': {
      borderColor: Colors.red,
      backgroundColor: Colors.red,
      color: Colors.white,

      '& .MuiSvgIcon-root': {
        color: Colors.white,
      },

      '&.Mui-disabled': {
        borderColor: Colors.red,
        backgroundColor: Colors.red,
        color: Colors.white,
        opacity: 0.2,

        '& .MuiSvgIcon-root': {
          color: Colors.white,
        },
      },
    },

    '&.MuiButton-containedPrimary': {
      borderColor: Colors.binge,
      backgroundColor: Colors.binge,
      color: Colors.white,

      '& .MuiSvgIcon-root': {
        color: Colors.white,
      },

      '&.Mui-disabled': {
        borderColor: Colors.binge,
        backgroundColor: Colors.binge,
        color: Colors.white,
        opacity: 0.2,

        '& .MuiSvgIcon-root': {
          color: Colors.white,
        },
      },
    },

    '&.MuiButton-containedSecondary': {
      border: 'none',
      background: Colors.tabGradient,
      color: Colors.white,

      '& .MuiSvgIcon-root': {
        color: Colors.white,
      },

      '&.Mui-disabled': {
        border: 'none',
        background: Colors.cellBorder,
        color: Colors.info,
        opacity: 1,

        '& .MuiSvgIcon-root': {
          color: Colors.info,
        },
      },
    },

    '&:hover': {
      opacity: 0.8,
    },
  },

  '&.MuiButton-text': {
    color: Colors.darkGray,
    height: '21px',
    padding: '0px',
    fontSize: FontSizes.fontSize14,
    fontFamily: fontSecondary,

    '&.Mui-disabled': {
      color: Colors.darkGray,
      opacity: 0.7,
    },

    '&.MuiButton-textError': {
      color: Colors.red,

      '& .MuiSvgIcon-root': {
        color: Colors.red,
      },

      '&.Mui-disabled': {
        color: Colors.red,
        opacity: 0.2,

        '& .MuiSvgIcon-root': {
          color: Colors.red,
        },
      },
    },

    '&:hover': {
      color: Colors.blackPearl,
    },
  },
});
